<template>
  <v-dialog
    v-model="dialog"
    width="360px">
    <div class="dialog-container">
      <h2>Resolve Ticket</h2>
      <template v-if="!resolveStatus">
        <p>
          Are you sure to mark the ticket as 
          resolved?
        </p>
        <div class="dialog-footer">
          <div>
            <v-button @click="dialog = false">Cancel</v-button>
          </div>
          <div>
            <v-button
              type="primary"
              @click="handlerYes">Yes</v-button>
          </div>
        </div>
      </template>
      <template v-else>
        <p>The ticket has been marked as resolved.</p>
        <v-button
          type="primary"
          @click="handlerDone">Done</v-button>
      </template>
    </div>
  </v-dialog>
</template>
<script>
import { setResolvedTicket } from '@/api/ticket'
export default {
  name: 'ResolveTicket',
  props: {
    ticketId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      resolveStatus: false
    }
  },
  methods: {
    changeDialog() {
      this.resolveStatus = false
      this.dialog = !this.dialog
    },
    handlerYes() {
      this.network().setResolvedTicket()
    },
    handlerDone() {
      this.dialog = false
      this.$emit('success')
    },
    network() {
      return {
        setResolvedTicket: async (ticketId) => {
          const { data } = await setResolvedTicket({
            ticket_id: [this.ticketId]
          })
          this.resolveStatus = true
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    .el-checkbox {
      margin: 10px 0;
    }
    p {
      padding-bottom: 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
  }
</style>